import PropTypes from 'prop-types';
import { Button, IconButton, Stack, Typography } from '@mui/material';
import { useFieldArray } from 'react-hook-form';
import ClearIcon from '@mui/icons-material/Clear';

export const DynamicFieldArray = ({
  control,
  name,
  fieldConfig,
  errors,
  addButtonText = 'Add More',
  FieldComponent,
}) => {
  const { fields, append, remove } = useFieldArray({ control, name });

  const handleAppend = () => {
    const newField = fieldConfig.reduce((acc, field) => ({ ...acc, [field.name]: '' }), {});
    append(newField);
  };

  return (
    <Stack spacing={2}>
      {fields.map((field, index) => (
        <Stack
          key={field.id}
          spacing={1}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography
              component="h6"
              variant="subtitle2"
            >
              {`${name.charAt(0).toUpperCase() + name.slice(1)} ${index + 1}`}
            </Typography>
            <IconButton
              aria-label="delete"
              size="small"
              onClick={() => remove(index)}
              sx={{ borderRadius: '8px', backgroundColor: '#f2f2f2' }}
            >
              <ClearIcon sx={{ fontSize: 20, color: '#404040' }} />
            </IconButton>
          </Stack>

          {fieldConfig.map(({ label, type = 'text', name: fieldName }) => (
            <FieldComponent
              key={`${name}.${index}.${fieldName}`}
              id={`${name}-${fieldName}-${index}`}
              name={`${name}.${index}.${fieldName}`}
              control={control}
              label={label}
              type={type}
              error={errors?.[name]?.[index]?.[fieldName]?.message}
            />
          ))}
        </Stack>
      ))}

      <Stack
        direction="row"
        justifyContent="end"
      >
        <Button
          variant="text"
          onClick={handleAppend}
        >
          {addButtonText}
        </Button>
      </Stack>
    </Stack>
  );
};

DynamicFieldArray.propTypes = {
  control: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  fieldConfig: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      type: PropTypes.string,
    })
  ).isRequired,
  errors: PropTypes.object,
  addButtonText: PropTypes.string,
  FieldComponent: PropTypes.elementType.isRequired,
};
